import { exportProFormaToExcel } from '../proFormaExcelExport';
import { IProFormaExcelData } from '../types';
import { LD_EXCEL_SHEET_NAMES } from './constants';
import { formatLdCashFlowSheet } from './cashFlowSheet';
import { formatLdDevelopmentBudgetSheet } from './developmentBudgetSheet';
import { formatLdDispositionSheet } from './dispositionSheet';
import { formatLdReturnsSummarySheet } from './returnsSummarySheet';
import { formatLdSummaryAssumptionsSheet } from './summaryAssumptionsSheet';
import { IExportLandDevelopmentToExcelParams } from './types';

export const handleExportLandDevelopmentToExcel = async ({
    proForma,
    usesSummary,
    sourcesSummary,
    disposition,
    returns,
    residentialLotMixes,
    otherRevenue,
    salesSchedule,
    sourceTypes,
    showCents = false,
}: IExportLandDevelopmentToExcelParams): Promise<void> => {
    const dealName = proForma.dealName || proForma.name || 'Pro Forma';
    const today = new Date();
    const dateStr = `${String(today.getMonth() + 1).padStart(2, '0')}${String(today.getDate()).padStart(2, '0')}${today.getFullYear()}`;
    const fileName = `${dealName} - Land Development - ${dateStr}`;

    const excelData: IProFormaExcelData = {
        fileName,
        sheets: [
            {
                sheetName: LD_EXCEL_SHEET_NAMES.SUMMARY_ASSUMPTIONS,
                sheetData: formatLdSummaryAssumptionsSheet({
                    proForma,
                    residentialLotMixes,
                    disposition,
                    salesSchedule,
                    usesSummary,
                }),
            },
            {
                sheetName: LD_EXCEL_SHEET_NAMES.DEVELOPMENT_BUDGET,
                sheetData: formatLdDevelopmentBudgetSheet({
                    dealName,
                    proForma,
                    usesSummary,
                    sourcesSummary,
                    showCents,
                }),
            },
            {
                sheetName: LD_EXCEL_SHEET_NAMES.DISPOSITION,
                sheetData: formatLdDispositionSheet({
                    dealName,
                    proForma,
                    disposition,
                    residentialLotMixes,
                    otherRevenue,
                    salesSchedule,
                    returns,
                    usesSummary,
                    showCents,
                }),
            },
            {
                sheetName: LD_EXCEL_SHEET_NAMES.CASH_FLOW,
                sheetData: formatLdCashFlowSheet({
                    dealName,
                    returns,
                    showCents,
                }),
            },
            {
                sheetName: LD_EXCEL_SHEET_NAMES.RETURNS_SUMMARY,
                sheetData: formatLdReturnsSummarySheet({
                    dealName,
                    proForma,
                    returns,
                    disposition,
                    sourcesSummary,
                    sourceTypes,
                    showCents,
                }),
            },
        ],
    };

    await exportProFormaToExcel(excelData);
};

export type { IExportLandDevelopmentToExcelParams } from './types';
